/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { CapacitorHttp } from '@capacitor/core';
import { HttpParameterCodec, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import Session from 'supertokens-web-js/recipe/session';
import { AuthStrategy } from '@generator-strategies/auth-strategy';
import { TenantStrategy } from '@generator-strategies/tenant-strategy';

// @ts-ignore
import { CreateAccountDto } from '../model/createAccountDto';
// @ts-ignore
import { CreateDependentDto } from '../model/createDependentDto';
// @ts-ignore
import { GetCheckinsDto } from '../model/getCheckinsDto';
// @ts-ignore
import { GetDocumentDto } from '../model/getDocumentDto';
// @ts-ignore
import { GetFamilyCheckinsDto } from '../model/getFamilyCheckinsDto';
// @ts-ignore
import { GetRevspringCurrentUserDto } from '../model/getRevspringCurrentUserDto';
// @ts-ignore
import { GetRevspringFamilyUsersDto } from '../model/getRevspringFamilyUsersDto';
// @ts-ignore
import { GetRevspringPatientIdsDto } from '../model/getRevspringPatientIdsDto';
// @ts-ignore
import { TokenDto } from '../model/tokenDto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

@Injectable({
  providedIn: 'root'
})
export class ExternalNextLevelService {
  protected basePath = 'http://localhost';
  public defaultHeaders: any = {};
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    @Optional()@Inject(BASE_PATH) basePath: string|string[],
    @Optional() configuration: Configuration,
    @Optional() private readonly authStrategy: AuthStrategy,
    @Optional() private readonly tenantStrategy: TenantStrategy,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      if (Array.isArray(basePath) && basePath.length > 0) {
        basePath = basePath[0];
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }


  /**
   * @param createDependentDto 
   */
  public async externalNextLevelControllerCreateDependent(createDependentDto: CreateDependentDto, ): Promise<any> {
    if (createDependentDto === null || createDependentDto === undefined) {
      throw new Error('Required parameter createDependentDto was null or undefined when calling externalNextLevelControllerCreateDependent.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/createDependent`,
        data: createDependentDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param createAccountDto 
   */
  public async externalNextLevelControllerCreateUser(createAccountDto: CreateAccountDto, ): Promise<any> {
    if (createAccountDto === null || createAccountDto === undefined) {
      throw new Error('Required parameter createAccountDto was null or undefined when calling externalNextLevelControllerCreateUser.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/createUser`,
        data: createAccountDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param tokenDto 
   */
  public async externalNextLevelControllerGetAppointments(tokenDto: TokenDto, ): Promise<any> {
    if (tokenDto === null || tokenDto === undefined) {
      throw new Error('Required parameter tokenDto was null or undefined when calling externalNextLevelControllerGetAppointments.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/appointments`,
        data: tokenDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getCheckinsDto 
   */
  public async externalNextLevelControllerGetCheckins(getCheckinsDto: GetCheckinsDto, ): Promise<any> {
    if (getCheckinsDto === null || getCheckinsDto === undefined) {
      throw new Error('Required parameter getCheckinsDto was null or undefined when calling externalNextLevelControllerGetCheckins.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/checkins`,
        data: getCheckinsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getDocumentDto 
   */
  public async externalNextLevelControllerGetDocuments(getDocumentDto: GetDocumentDto, ): Promise<any> {
    if (getDocumentDto === null || getDocumentDto === undefined) {
      throw new Error('Required parameter getDocumentDto was null or undefined when calling externalNextLevelControllerGetDocuments.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/documents`,
        data: getDocumentDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getFamilyCheckinsDto 
   */
  public async externalNextLevelControllerGetFamilyCheckins(getFamilyCheckinsDto: GetFamilyCheckinsDto, ): Promise<any> {
    if (getFamilyCheckinsDto === null || getFamilyCheckinsDto === undefined) {
      throw new Error('Required parameter getFamilyCheckinsDto was null or undefined when calling externalNextLevelControllerGetFamilyCheckins.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/family-checkins`,
        data: getFamilyCheckinsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param tokenDto 
   */
  public async externalNextLevelControllerGetResults(tokenDto: TokenDto, ): Promise<any> {
    if (tokenDto === null || tokenDto === undefined) {
      throw new Error('Required parameter tokenDto was null or undefined when calling externalNextLevelControllerGetResults.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/results`,
        data: tokenDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getRevspringCurrentUserDto 
   */
  public async externalNextLevelControllerGetRevspringCurrentUser(getRevspringCurrentUserDto: GetRevspringCurrentUserDto, ): Promise<any> {
    if (getRevspringCurrentUserDto === null || getRevspringCurrentUserDto === undefined) {
      throw new Error('Required parameter getRevspringCurrentUserDto was null or undefined when calling externalNextLevelControllerGetRevspringCurrentUser.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/revspring-current-user`,
        data: getRevspringCurrentUserDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getRevspringFamilyUsersDto 
   */
  public async externalNextLevelControllerGetRevspringFamilyUsers(getRevspringFamilyUsersDto: GetRevspringFamilyUsersDto, ): Promise<any> {
    if (getRevspringFamilyUsersDto === null || getRevspringFamilyUsersDto === undefined) {
      throw new Error('Required parameter getRevspringFamilyUsersDto was null or undefined when calling externalNextLevelControllerGetRevspringFamilyUsers.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/revspring-family-users`,
        data: getRevspringFamilyUsersDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param getRevspringPatientIdsDto 
   */
  public async externalNextLevelControllerGetRevspringPatientIDs(getRevspringPatientIdsDto: GetRevspringPatientIdsDto, ): Promise<any> {
    if (getRevspringPatientIdsDto === null || getRevspringPatientIdsDto === undefined) {
      throw new Error('Required parameter getRevspringPatientIdsDto was null or undefined when calling externalNextLevelControllerGetRevspringPatientIDs.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/revspring-patient-ids`,
        data: getRevspringPatientIdsDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
  /**
   * @param tokenDto 
   */
  public async externalNextLevelControllerGetVitals(tokenDto: TokenDto, ): Promise<any> {
    if (tokenDto === null || tokenDto === undefined) {
      throw new Error('Required parameter tokenDto was null or undefined when calling externalNextLevelControllerGetVitals.');
    }

    const localVarHeaders = this.defaultHeaders;

    const token = await Session.getAccessToken();
    localVarHeaders['content-type'] = 'application/json';
    localVarHeaders['Authorization'] = `Bearer ${token}`;
    localVarHeaders['X-USER-TIMEZONE'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    localVarHeaders['X-TENANT-ID'] = this.tenantStrategy?.organizationId();
    const response = await CapacitorHttp.post({
      url: `${this.configuration.basePath}/api/external-integrations/external-next-level/vitals`,
        data: tokenDto,
      headers: localVarHeaders,
    });
    if (response?.status >= 400) {
      if (response?.status === 401) {
        await this.authStrategy.signOut();
      }
      throw new HttpErrorResponse({
        error: response.data,
        status: response.status,
        url: response.url,
      });
    } else {
      return response.data;
    }
  }
}
